/* SKROT „MOJE OBSERWACJE I SZKICE" NA STRONIE GLOWNEJ — Fala 3 (30.09.2026).
 *
 * Czyta TYLKO lokalne metadane (liczebnosci) z dwoch istniejacych kluczy:
 * pewniaki:obserwowane-liczby:v1 (obserwacje, Fala 1) i pewniaki:szkic-zestawu:v1
 * (szkice, Fala 2) — bez zapisu, bez pobierania pakietow analiz ani profili,
 * bez pokazywania wybranych liczb. Zamknieta lista gier i pul z atrybutow
 * wierszy (Twig, slownik gier); klucze odziedziczone obiektu nie sa grami.
 * Blok pojawia sie tylko przy obserwacjach albo rozpoczetym szkicu; zmiana w
 * innej karcie (storage) odswieza stan; usuniecie ostatnich danych chowa blok.
 * Adresy i teksty sa w SSR (mapa tras i tr()), skrypt tylko wypelnia liczniki. */
(function (root, doc) {
    'use strict';
    if (!doc) { return; }
    var KLUCZ_OBS = 'pewniaki:obserwowane-liczby:v1', KLUCZ_SZK = 'pewniaki:szkic-zestawu:v1';
    function wlasne(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
    function odczyt(klucz) {
        var s = null;
        try { s = root.localStorage.getItem(klucz); } catch (e) { return null; }
        if (s === null) { return null; }
        try { var d = JSON.parse(s); return d && typeof d === 'object' && !Array.isArray(d) ? d : null; } catch (e) { return null; }
    }
    function ileObserwacji(d, gra, pula) {
        if (!d || d.v !== 1 || !d.gry || typeof d.gry !== 'object' || !wlasne(d.gry, gra) || !Array.isArray(d.gry[gra])) { return 0; }
        var seen = {}, n = 0;
        d.gry[gra].forEach(function (x) { if (typeof x === 'number' && Math.floor(x) === x && x >= 1 && x <= pula && !seen[x] && n < 20) { seen[x] = true; n++; } });
        return n;
    }
    function ileSzkicu(d, gra, pula, pulaD) {
        if (!d || d.v !== 1 || !d.gry || typeof d.gry !== 'object' || !wlasne(d.gry, gra) || !d.gry[gra] || typeof d.gry[gra] !== 'object') { return 0; }
        var w = d.gry[gra], n = 0, seen = {};
        if (Array.isArray(w.liczby)) { w.liczby.forEach(function (x) { if (typeof x === 'number' && Math.floor(x) === x && x >= 1 && x <= pula && !seen[x] && n < 20) { seen[x] = true; n++; } }); }
        var seenD = {}, m = 0;
        if (pulaD > 0 && Array.isArray(w.dodatkowe)) { w.dodatkowe.forEach(function (x) { if (typeof x === 'number' && Math.floor(x) === x && x >= 1 && x <= pulaD && !seenD[x] && m < 2) { seenD[x] = true; m++; } }); }
        return n + m;
    }
    function start() {
        var box = doc.querySelector('[data-mo-skrot]');
        if (!box) { return; }
        var teksty = {};
        try { teksty = JSON.parse((box.querySelector('[data-mo-teksty]') || { textContent: '{}' }).textContent) || {}; } catch (e) { teksty = {}; }
        function t(k, n) { return String(teksty[k] || k).replace('${n}', String(n)); }
        var wiersze = Array.prototype.slice.call(box.querySelectorAll('[data-mo-gra]'));
        function odswiez() {
            var obs = odczyt(KLUCZ_OBS), szk = odczyt(KLUCZ_SZK), jest = false;
            wiersze.forEach(function (w) {
                var gra = w.getAttribute('data-mo-gra'), pula = parseInt(w.getAttribute('data-mo-pula'), 10) || 0, pulaD = parseInt(w.getAttribute('data-mo-pula-dodatkowa'), 10) || 0;
                var maSzkic = w.getAttribute('data-mo-szkic') === '1';
                var o = ileObserwacji(obs, gra, pula), s = maSzkic ? ileSzkicu(szk, gra, pula, pulaD) : 0;
                var eO = w.querySelector('[data-mo-obs]'), eS = w.querySelector('[data-mo-szk]'), lO = w.querySelector('[data-mo-link-obs]'), lS = w.querySelector('[data-mo-link-szk]');
                if (eO) { eO.textContent = o ? t('obs', o) : ''; eO.hidden = !o; }
                if (eS) { eS.textContent = s ? t('szkic', s) : ''; eS.hidden = !s; }
                if (lO) { lO.hidden = !o; }
                if (lS) { lS.hidden = !s; }
                w.hidden = !(o || s);
                if (o || s) { jest = true; }
            });
            box.hidden = !jest;
        }
        root.addEventListener('storage', function (e) { if (e.key === null || e.key === KLUCZ_OBS || e.key === KLUCZ_SZK) { odswiez(); } });
        doc.addEventListener('pewniaki:obserwowane-zmiana', odswiez);
        doc.addEventListener('pewniaki:szkic-zmiana', odswiez);
        odswiez();
    }
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); } else { start(); }
})(typeof window !== 'undefined' ? window : this, typeof document !== 'undefined' ? document : null);
